/**
 * Configuração única de segmentos de cliente do dashboard.
 * Cada tipo de usuário vira uma aba e um bloco de métricas automaticamente.
 * Para suportar um novo tipo de cliente no futuro, basta adicionar uma entrada aqui.
 */

export const USER_SEGMENTS = [
  {
    key: "individual",
    label: "Individual",
    userType: 0,
    accent: "#2AF598",
    borderColor: "rgba(42, 245, 152, 0.28)",
  },
  {
    key: "corporate",
    label: "Corporate",
    userType: 1,
    accent: "#3A87DE",
    borderColor: "rgba(58, 135, 222, 0.28)",
  },
];

/** Segmento default quando o user_type não casa com nenhum configurado. */
export const DEFAULT_SEGMENT = USER_SEGMENTS[0];

/** Resolve o segmento de um usuário a partir do user_type (número ou string). */
export const getSegmentForUser = (user) => {
  const rawType = user?.user_type;

  if (typeof rawType === "string") {
    const normalized = rawType.toLowerCase();
    const byLabel = USER_SEGMENTS.find((segment) => segment.key === normalized);
    if (byLabel) return byLabel;
  }

  const byType = USER_SEGMENTS.find((segment) => segment.userType === rawType);
  return byType || DEFAULT_SEGMENT;
};

/** Chave do segmento de um usuário (atalho). */
export const getSegmentKeyForUser = (user) => getSegmentForUser(user).key;
